module.exports = __webpack_public_path__ + "static/img/11.e7b2b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/11.png
// module id = nrPC
// module chunks = 0